import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererStatus from "@/components/visit-point/list/cell-renderer/CellRendererStatus.vue";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const visitPoinListMixin = {
	name: "VisitPoinListDatarutas",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					showItemsPerPage: true,
					showPopup: false,
					showActions: false,
					tableOptions: false,
				};
			},
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		status_id: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererStatus,
	},
	data() {
		return {
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			departmentFilter: {label: "All", value: "all"},
			searchQuery: [],
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
			searchField: "Identification",
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererStatus,
			},
		};
	},
	watch: {
		roleFilter(obj) {
			this.setColumnFilter("typology_name", obj.value);
		},
		statusFilter(obj) {
			this.setColumnFilter("status_name", obj.value);
		},
		isVerifiedFilter(obj) {
			let val = "";
			if (obj.value === "all") {
				val = "all";
			} else if (obj.value === "yes") {
				val = "true";
			} else {
				val = "false";
			}
			this.setColumnFilter("is_verified", val);
		},
		departmentFilter(obj) {
			this.setColumnFilter("department", obj.value);
		},
		currentPageLocal(page) {
			this.getVisitPoint(page);
		},
		quantityElementPage() {
			this.getVisitPoint(1);
		},
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let columns = [
				{
					headerName: this.$t("Routing.Table.Identification"),
					field: "identification",
					width: 220,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
				},
				{
					headerName: this.$t("Name"),
					field: "name",
					width: 300,
				},
				{
					headerName: this.$t("Address"),
					field: "address",
					width: 200,
				},
				{
					headerName: this.$t("Divipola.City"),
					field: "city",
					width: 200,
				},
				{
					headerName: this.$t("Divipola.Department"),
					field: "department",
					width: 200,
				},
				{
					headerName: this.$t("Divipola.Country"),
					field: "country",
					width: 200,
				},
				{
					headerName: this.$t("TypeConfig.Form.Status"),
					field: "status_name",
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}

			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`ResourceModule.Table.${this.searchField}`);
		},
		usersData() {
			return this.$store.state.moduleVisitPoint.visitPointsDatarutas === undefined ||
				this.$store.state.moduleVisitPoint.visitPointsDatarutas === "" ||
				this.$store.state.moduleVisitPoint.visitPointsDatarutas === null
				? []
				: this.$store.state.moduleVisitPoint.visitPointsDatarutas;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsDatarutas === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDatarutas === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDatarutas === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsDatarutas;
		},
	},
	methods: {
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		async getVisitPoint(page) {
			this.onBtShowLoading();
			const payload = {
				page,
				quantity: this.quantityElementPage,
				sort: "desc",
				order_by: ["id"],
			};
			await this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginatedDatarutas", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		searchAssignedVisitPoint(searchField, searchQuery, page) {
			const searchQueryList = searchQuery.map(({value}) => value);
			const dataPage = {
				identification: searchField === "Identification" ? searchQueryList : [],
				address: searchField === "Address" ? searchQueryList : [],
				department: searchField === "Department" ? searchQueryList : [],
				city: searchField === "City" ? searchQueryList : [],
				page: page ? page : currentPageLocal,
				status_id: this.status_id,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginatedDatarutas", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		rowSelected(event) {
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_DATARUTAS", event.data);
			} else {
				this.$store.commit("moduleVisitPoint/REMOVE_VISIT_POINT_CHECKED_DATARUTAS", event.data);
			}
		},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedVisitPoints;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		refreshVisitPoint() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_DATARUTAS");
			this.getVisitPoint(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		this.getVisitPoint(1);
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_DATARUTAS");
	},
};
